import React from "react";
import { withStyles, withTheme } from "@material-ui/core";
import styles from "../../../styles";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import Map, {
  MapControls,
  MapConstant,
  Marker,
  Popup,
} from "../../../../../../lib/Map";
import MapAutoZoom from "../../../../../../layout/layoutHeader/components/MapAutoZoom";
import Events from "../../../../../../utilities/EventEmitter";
import { withAppConfig } from "../../../../../../appConfigContext";
import { TerminalMarker } from "../../../../../../components/mapComponents/Markers";
import DrawStyles from "../../../../../../lib/Map/Trimble/components/DrawStyles";
import DrawingTools from "../../../common/DrawTools/DrawingTools";
import MapDrawingToolBox from "../../../common/DrawTools/DrawingToolsBox";
import drawConstant from "../../../common/DrawTools/DrawConstant";
import terminalOnBoardingConstant from "../Constant";
import { ZonePopUpInfo } from "../../../../../mapComponents/Popups";

class OnboardTerminalMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAutoZoomEnabled: true,
      geoDataList: [],
      zoneInfo: null,
    };
    this.mapId = "OnboardTerminalMap"
  }

  componentDidUpdate(prevProps) {
    if (this.props.terminalGeoFencing !== prevProps.terminalGeoFencing) {
      const geoJson = this.getExistingFeaturesGeoJSON();
      this.setState({
        geoDataList: geoJson,
      });
    }
  }
  getExistingFeaturesGeoJSON = () => {
    const { terminalInfo, terminalGeoFencing } = this.props;
    return terminalGeoFencing
      ? [
          {
            id: terminalInfo?.terminalId || "new",
            type: "Feature",
            properties: {},
            geometry: {
              type: "Polygon",
              coordinates: [JSON.parse(terminalGeoFencing)],
            },
          },
        ]
      : [];
  };

  onScaleDrawingComplete = (feature, type) => {
    if (
      [
        MapConstant.DRAWING_EVENTS.CREATE,
        MapConstant.DRAWING_EVENTS.UPDATE,
      ].includes(type)
    ) {
      Events.emit(drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_UPDATED, feature);
    } else if (type === "delete") {
      Events.emit(drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_DELETED, feature);
    }
  };
  onMarkerDragEnd = (terminal) => {
    this.props.terminalPositionChange({
      latitude: terminal.position.lat,
      longitude: terminal.position.lng,
    });
  };

  toggleRouteAnimation = (value) => {
    this.setState({
      isAutoZoomEnabled: value,
    });
  };

  onZoneClicked = (zoneInfo) => {
    this.setState({ zoneInfo });
  };

  hideAllPopups = () => {
    this.setState({
        zoneInfo: null,
    });
  };

  onMapClick = (e) => {
    if (
      this.props.isTerminalFormOpen &&
      !this.props.terminalInfo &&
      !this.props.terminalPosition
    ) {
      this.props.terminalPositionChange({
        latitude: e.lat,
        longitude: e.lng,
      });
    }
    this.hideAllPopups();
    this.props.terminalClickedOnMap(null);
  };
  render() {
    const {
      classes,
      theme,
      data,
      configJSON,
      selectedTerminalIds,
      terminalClickedOnMap,
      isTerminalFormOpen,
      terminalInfo,
      terminalPosition,
    } = this.props;
    const { location: terminalLocation, code: terminalID } =
      this.props.userData.userProfile.terminal;
    const showAddMarkerPointer =
      isTerminalFormOpen && !terminalInfo && !terminalPosition;
    return (
      <div className={classes.anchorSubModulePart}>
        <header
          className={`${classes.moduleHeader} ${classes.anchorPointHeader}`}
          data-automationid="OnboardTerminalMap-title"
        >
          Terminal Geofencing
          <span className={classes.anchorPointAutoZoom}>
            <MapAutoZoom
              isEnabled={this.state.isAutoZoomEnabled}
              toggleRouteAnimation={this.toggleRouteAnimation}
              isMenuItem={true}
              eventHub={Events}
              title={`${
                this.state.isAutoZoomEnabled ? "Disable" : "Enable"
              } Auto Zoom`}
            ></MapAutoZoom>
            <MapDrawingToolBox hide={!isTerminalFormOpen} lasso delete />
          </span>
        </header>
        <div className={classes.anchorPointModuleContainer}>
          <div
            className={
              showAddMarkerPointer
                ? `${classes.anchorPointContent} ${classes.anchorPointMap}`
                : classes.anchorPointContent
            }
          >
            <Map
              zoom={this.state.isAutoZoomEnabled && isTerminalFormOpen ? 22 : 9}
              initialCenter={terminalLocation}
              center={terminalLocation}
              mapId={this.mapId}
              mapTheme={theme.themeName}
              mapConfig={configJSON?.maps}
              onClick={this.onMapClick}
            >
              <MapControls
                controlOptions={{
                  zoomControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  satelliteViewControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  reCenterMapControl: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                  },
                  showZones: {
                    position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
                    terminalID: terminalID,
                    onZoneClicked: this.onZoneClicked,
                    geoJson: this.props.userData.userProfile?.geoJson,
                  },
                }}
              />
              {!isTerminalFormOpen
                ? data?.map((terminal) => {
                    const isActive = selectedTerminalIds.includes(
                      terminal.terminalId
                    );
                    const size = isActive
                      ? terminalOnBoardingConstant.ACTIVE_ICON
                      : terminalOnBoardingConstant.SMALL_ICON;
                    return (
                      <Marker
                        data={{ ...terminal, size }}
                        position={{
                          lat: terminal.latitude,
                          lng: terminal.longitude,
                        }}
                        key={terminal.terminalCode}
                        onClick={terminalClickedOnMap}
                        forceUpdate={true}
                        isActiveShipment={
                          this.state.isAutoZoomEnabled && isActive
                        }
                        zIndex={1}
                      >
                        <TerminalMarker
                          data={{
                            name: terminal.terminalName,
                            address: terminal.address,
                            size,
                          }}
                        />
                      </Marker>
                    );
                  })
                : null}

              {isTerminalFormOpen &&
              (Boolean(terminalPosition) || Boolean(terminalInfo)) ? (
                <Marker
                  data={terminalInfo || {}}
                  position={
                    terminalPosition
                      ? {
                          lat: terminalPosition.latitude,
                          lng: terminalPosition.longitude,
                        }
                      : {
                          lat: terminalInfo.latitude,
                          lng: terminalInfo.longitude,
                        }
                  }
                  key={terminalInfo ? terminalInfo.terminalId : "new"}
                  draggable={true}
                  onDragEnd={this.onMarkerDragEnd}
                  zIndex={1} // display active shipments on top
                  forceUpdate={true}
                  isActiveShipment={this.state.isAutoZoomEnabled}
                >
                  <TerminalMarker
                    data={{
                      name: terminalInfo?.terminalName || null,
                      address: terminalInfo?.address || null,
                      size: terminalOnBoardingConstant.ACTIVE_ICON,
                    }}
                  />
                </Marker>
              ) : null}

              <DrawingTools
                singleColorDraw={true}
                polygonOptions={{
                  fillColor: theme.MapDrawingColor,
                  strokeColor: theme.MapDrawingColor,
                }}
                geoDataList={this.state.geoDataList}
                styleArray={DrawStyles(theme.commonAppHeaderTabColor)}
                eventHub={Events}
                featureIds={
                  terminalInfo?.geoFence ? [terminalInfo.terminalId] : []
                }
                onDrawingComplete={this.onScaleDrawingComplete}
                mode={isTerminalFormOpen && !terminalInfo?.geoFence ? "create" : "edit"}
                disableAutoRecenter={true}
              />
              {this.state.zoneInfo && (
                <Popup isCloseButton position={this.state.zoneInfo.position}>
                  <ZonePopUpInfo data={this.state.zoneInfo.data} />
                </Popup>
              )}
            </Map>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme(),
  withUserProfile,
  withAppConfig
)(OnboardTerminalMap);
